import { Service, inject } from '@angular/core'
import {
  SetActivityStatusBody,
  CreateActivityBody,
  EditActivityBody,
  GetManagedActivitiesResponse,
  ManagedActivity,
  DeleteEntityResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageActivityApiService {
  private readonly api = inject(ApiService)

  getManagedActivities(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<GetManagedActivitiesResponse>(`manage/entities/${entityId}/activities`, {
      ...init,
    })
  }

  getManagedActivity(entityId: string, activityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedActivity>(`manage/entities/${entityId}/activities/${activityId}`, {
      ...init,
    })
  }

  createActivity(entityId: string, body: CreateActivityBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedActivity>(`manage/entities/${entityId}/activities`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editActivity(entityId: string, activityId: string, body: EditActivityBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedActivity>(`manage/entities/${entityId}/activities/${activityId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...init,
    })
  }

  deleteActivity(entityId: string, activityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(`manage/entities/${entityId}/activities/${activityId}`, {
      method: 'DELETE',
      ...init,
    })
  }

  setActivityStatus(entityId: string, activityId: string, body: SetActivityStatusBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedActivity>(`manage/entities/${entityId}/activities/${activityId}/status`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
